
























































































import { defineComponent, computed, ref, PropType, reactive, Ref } from '@vue/composition-api';
import navLink from '../header/navigation/nav-link.vue';
import subList from '../header/navigation/sub-list.vue';
import userInfo from './userInfo.vue';
import { useLog } from '@/common/log';

import { NAVIGATION_LIST, NavItem } from './config';
import SvgIcon from '../svg-icon/index.vue';
import { useTvVersion } from './util';
import OttModel from '@/models/ott-config';
import { useApolloModel } from 'vue-apollo-model';
import type { TextItemUI } from '../../../typings/ui';


export default defineComponent({
    components: {
        navLink,
        subList,
        userInfo,
        SvgIcon,
    },
    props: {
        isFixed: Boolean,
        navUiData: {
            type: Object as PropType<TextItemUI>,
        },
        loginUiData: {
            type: Object as PropType<{background: string; color: string;}>,
        },
    },
    setup(props) {
        const log = useLog();
        const navigationList = ref(NAVIGATION_LIST);
        const ottModel = useApolloModel(OttModel);
        const ottApkUrl = computed<string>(() => ottModel.ottConfig.apkUrl);
        const toolItemList: Ref<HTMLDivElement[] | null> = ref(null);
        const navItemUIData = computed(() => {
            if (props.navUiData) {
                return {
                    color: props.navUiData?.defaultState.fontColor,
                    fontWeight: props.navUiData?.defaultState.fontWeight,
                };
            }
        });
        const hoverUIData = computed(() => {
            if (props.navUiData) {
                return {
                    color: props.navUiData?.hoverState.fontColor,
                    fontWeight: props.navUiData?.hoverState.fontWeight,
                };
            }
        });
        const { clickNewTv } = useTvVersion(ottApkUrl, navigationList, log);
        async function handleClickNavItem(item: NavItem) {
            if (item.id === 'tv') {
                // 点击TV时，需要获取下最新配置，保证后面埋点逻辑正确
                await ottModel.config.refetch();
                clickNewTv(ottApkUrl.value);
            }
            log({
                type: 'CLICK',
                event_name: 'TOP_TAB_BUTTON',
                event_value: {
                    icon: item.name,
                },
            });
        }
        function handleMove(index: number, action: 'enter' | 'leave') {
            if (toolItemList.value) {
                if (action === 'enter') {
                    toolItemList.value[index].style.color = hoverUIData.value?.color || '';
                } else {
                    toolItemList.value[index].style.color = navItemUIData.value?.color || '';
                }
            }
        }
        return {
            navigationList,
            navItemUIData,
            hoverUIData,
            toolItemList,
            log,
            handleClickNavItem,
            handleMove,
        };
    },
});

